export default "__VITE_ASSET__CW3Iu44A__"